import { type ReactNode } from 'react';
import * as stylex from '@stylexjs/stylex';
import { sentinel } from '../theme/semantic.stylex';

const styles = stylex.create({
  root: {
    display: 'grid',
    placeItems: 'center',
    gap: '0.75rem',
    padding: '3rem 1.5rem',
    textAlign: 'center',
    backgroundColor: sentinel.surfaceElevated,
    borderRadius: '0.625rem',
    borderWidth: '1px',
    borderStyle: 'dashed',
    borderColor: sentinel.borderDefault,
  },
  icon: {
    width: '2.5rem',
    height: '2.5rem',
    display: 'grid',
    placeItems: 'center',
    color: sentinel.textSubtle,
    marginBottom: '0.25rem',
  },
  title: {
    margin: 0,
    fontFamily: sentinel.fontDisplay,
    fontSize: '1.0625rem',
    fontWeight: 600,
    color: sentinel.textBody,
    letterSpacing: '-0.01em',
  },
  description: {
    margin: 0,
    fontFamily: sentinel.fontBody,
    fontSize: '0.9375rem',
    color: sentinel.textMuted,
    maxWidth: '40ch',
    lineHeight: 1.5,
  },
  actions: { display: 'flex', gap: '0.5rem', marginTop: '0.75rem' },
});

export interface EmptyStateProps {
  title: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  actions?: ReactNode;
  testId?: string;
}

export function EmptyState({ title, description, icon, actions, testId }: EmptyStateProps) {
  return (
    <div {...stylex.props(styles.root)} role="status" data-testid={testId}>
      {icon ? <div {...stylex.props(styles.icon)} aria-hidden="true">{icon}</div> : null}
      <h3 {...stylex.props(styles.title)}>{title}</h3>
      {description ? <p {...stylex.props(styles.description)}>{description}</p> : null}
      {actions ? <div {...stylex.props(styles.actions)}>{actions}</div> : null}
    </div>
  );
}
